<template>
  <div :class="['lvls_box trans_box', {current: isCurrent}]">
    <div class="flex-row outer">
      <div class="trans_box lvl">
        <div class="flex-row">
          <BaseImage :src="levelImage" alt="level" />
          <p>{{ $_translations.value.common_level_short }} {{ levelNumber }}</p>
        </div>
      </div>

      <h3>{{ $_translations.value[levelName] }}</h3>
    </div>

    <p class="paragr">
      {{ $_translations.value[levelDescription] }}
    </p>

    <template v-if="isCurrent">
      <p class="game_count">
        <span>{{ authStore.user.gamesPlayed }}</span> / {{ levelThreshold }}
        {{ $_translations.value.page_levels_games }}
      </p>

      <BaseProgressBar :value="authStore.userNextLevelProgressPercentage" />

      <BaseButton
        v-if="authStore.hasUserAvailableGames"
        @click:button="$emit('start:game')"
      >
        {{ $_translations.value.page_levels_button_play }}
      </BaseButton>

      <BaseButton
        v-else-if="!appSettingsStore.isStoreDisabled"
        @click:button="$emit('redirect:storePage')"
      >
        {{ $_translations.value.page_levels_get_more_games }}
      </BaseButton>
    </template>

    <template v-else>
      <p class="game_count">
        {{ levelThreshold }} {{ $_translations.value.page_levels_games }}
      </p>
    </template>

    <BaseImage
      v-if="isCompleted"
      src="/static/images/level_completed.svg"
      image-class="lvl_status"
      alt="checked"
    />

    <BaseImage
      v-else-if="isNext"
      src="/static/images/level_locked.svg"
      image-class="lvl_status"
      alt="locked"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseProgressBar from '@/components/bar/BaseProgressBar.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import { getLevelNameTranslationKey, getLevelNumberImage } from '@/helpers/reward.js';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';

defineEmits(['start:game', 'redirect:storePage']);

const props = defineProps({
  item: {
    type: Object,
    default: () => ({
      levelName: '',
      prizeType: '',
      threshold: 0,
      prizeValue: 0,
      __level: 0,
    }),
  },
});

const appSettingsStore = useAppSettingsStore();
const authStore = useAuthStore();

const levelNumber = computed(() => props.item.__level);
const levelName = computed(() => getLevelNameTranslationKey(levelNumber.value));
const levelImage = computed(() => getLevelNumberImage(levelNumber.value));
const levelDescription = computed(() => `level_description_${ props.item.levelName }`);
const levelThreshold = computed(() => props.item.threshold);
const isCurrent = computed(() => !authStore.hasUserCompletedAllLevels && (props.item.__level === authStore.userNextLevelNumber));
const isCompleted = computed(() => authStore.hasUserCompletedAllLevels || (props.item.__level < authStore.userNextLevelNumber));
const isNext = computed(() => !authStore.hasUserCompletedAllLevels && (props.item.__level > authStore.userNextLevelNumber));
</script>
